"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StreetLights = function StreetLights(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 20 20", className: "custom-icon" }, props),
    _react2.default.createElement("path", {
      d: "M5.8682079,18.7636513 L4.71650354,18.7636513 L4.71650354,14.358129 C4.71650354,14.0167207 4.42185463,13.7399547 4.05838677,13.7399547 L3.59331758,13.7399547 L3.59331758,1.85452298 C3.59331758,1.51311472 3.8879665,1.23634865 4.25143436,1.23634865 L8.25497806,1.23634865 C8.61844592,1.23634865 8.91309484,1.51311472 8.91309484,1.85452298 L8.91309484,2.81475376 C7.28155285,3.10202802 6.09852146,4.43913985 6.09635505,5.99835154 C6.09635505,6.33975979 6.39100396,6.61652586 6.75447182,6.61652586 L7.85133311,6.61652586 C8.14363877,7.20390301 8.76908288,7.58139996 9.45933176,7.58705955 L9.62386095,7.58705955 C10.3188763,7.58616681 10.9506829,7.20792577 11.2450219,6.61652586 L12.3418832,6.61652586 C12.7053511,6.61652586 13,6.33975979 13,5.99835154 C12.9981348,4.45517092 11.8396631,3.12663144 10.2293284,2.8209355 L10.2293284,1.85452298 C10.2293284,0.830298218 9.34538164,4.57540913e-17 8.25497806,0 L4.25143436,0 C3.16103078,-4.57540913e-17 2.27708404,0.830298218 2.27708404,1.85452298 L2.27708404,13.7399547 L1.80982113,13.7399547 C1.44635327,13.7399547 1.15170435,14.0167207 1.15170435,14.358129 L1.15170435,18.7636513 L0,18.7636513 L0,20 L5.8682079,20 L5.8682079,18.7636513 Z M11.5718866,5.3698743 L7.51569355,5.3698743 C7.8011886,4.54339708 8.62094637,3.98371681 9.5459838,3.98371681 C10.4710212,3.98371681 11.290779,4.54339708 11.576274,5.3698743 L11.5718866,5.3698743 Z M3.39588255,18.7636513 L2.4679379,18.7636513 L2.4679379,14.9763033 L3.40027,14.9763033 L3.39588255,18.7636513 Z",
      id: "path-1"
    })
  );
};

exports.default = StreetLights;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/streetlights.js
// module id = ../lib/egov-ui-kit/custom-icons/streetlights.js
// module chunks = 504